import { ApiBaseService } from '@/services/ApiBase.service'
import { NotificationSubscription } from '@/classes/generated-models'

export class NotificationService extends ApiBaseService<NotificationSubscription, NotificationSubscription[]> {
  readonly apiController = 'notifications'
}
